import Vue from 'vue'
import master from '../masterModules/masterModule.js'
// careworker-action
const URL = process.env.API_URL
const header = master.state.header

export default {
  inputUpdate(store, payload) {
    store.commit('inputUpdate', payload)
  },
  inputAddUpdate(store, payload) {
    store.commit('inputAddUpdate', payload)
  },
  clearCareworker(store) {
    store.commit('clearCareworker')
  },
  updateSelectedCareworkerList(store, payload) {
    store.commit('updateSelectedCareworkerList', payload)
  },
  clearSelectedCareworkerList(store) {
    store.commit('clearSelectedCareworkerList')
  },
  async addCareworker(store, payload) {
    await store.commit('changeAddUserBirthday', payload)
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [
        {
          users: [store.state.addUser]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/user/regist',
      data,
      config
    )
    // 成功
    // 追加後の処理
    store.commit('setCareworkers', response)
  },
  async setCareworkers(store, payload) {
    store.state.careworkers = []
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          pageNo: payload.pageNo,
          count: 20,
          searchWord: payload.searchWord
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/user/list',
      data,
      config
    )
    // 成功
    store.commit('setCareworkers', response)
  },
  async updateCareworker(store, payload) {
    await store.commit('changeUpdateUserBirthday', payload)
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [
        {
          users: [store.state.updateUser]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/user/update',
      data,
      config
    )
    // 成功
    // 更新後の処理
    store.commit('setCareworkers', response)
  },
  async deleteCareworkers(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [
        {
          users: payload
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/user/delete',
      data,
      config
    )
    // 成功
    // 削除後の処理
    store.commit('setCareworkers', response)
  },
  async setDetailCareworker(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          users: [
            {
              userId: payload.userId
            }
          ]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/user/detail',
      data,
      config
    )
    // 成功
    if (response.data['data'][0].thumbnailPhotograph == null) {
      store.state.changeThumbnailPhotograph = require('../../../img/noimageicon.png')
    }
    await store.commit('setDetail', response)
  },
  async deletePassword(store) {
    await store.commit('deletePassword')
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 300
    }
    const data = {
      header,
      data: [
        {
          users: [
            {
              userId: store.state.changePassword.userId,
              passwordToken: store.state.changePassword.passwordToken
            }
          ]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/user/update',
      data,
      config
    )
    // 成功
    // 更新後の処理
    store.commit('setCareworkers', response)
  },
  async fileUpload(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    let data = new FormData()
    data.append('companyid', master.state.loginCompanyId)
    data.append('imageuserid', store.state.careworker.userId)

    let imageSrc = await loadImageFile(payload)
    const image = await loadImage(imageSrc)
    const scale = getImageScale(image)
    let imageObject = payload
    if (scale < 1) {
      imageObject = await getImageBlob(image, scale)
      data.append('imageFiles', imageObject, 'image.jpg')
    } else {
      data.append('imageFiles', imageObject)
    }

    data.append('loginUserId', header.userId)
    await Vue.http.post(URL + '/v2/admin/userimage/upload', data, config)
    await store.dispatch('setThumbnailPhotoGraph', store.state.careworker)
  },
  async fileDelete(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          userId: store.state.careworker.userId
        }
      ]
    }
    await Vue.http.post(URL + '/v2/admin/userimage/delete', data, config)
    await store.dispatch('setThumbnailPhotoGraph', store.state.careworker)
  },
  async setThumbnailPhotoGraph(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          users: [
            {
              userId: payload.userId
            }
          ]
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/user/detail',
      data,
      config
    )
    // 成功
    if (response.data['data'][0].thumbnailPhotograph == null) {
      store.state.changeThumbnailPhotograph = require('../../../img/noimageicon.png')
      store.state.careworker.thumbnailPhotograph = ''
    } else {
      store.state.careworker.thumbnailPhotograph =
        response.data['data'][0].thumbnailPhotograph
    }
  },
  async importUsers(store, payload) {
    let logContinue = true
    let pageNo = 0
    const count = 200
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: [
          {
            users: payload.slice(pageNo * count, pageNo * count + count),
            startFlag: pageNo === 0,
            endFlag: false
          }
        ]
      }

      const size = payload.length
      pageNo++
      if (size <= pageNo * count) {
        data.data[0].endFlag = true
        logContinue = false
      }

      await Vue.http.post(URL + '/v2/admin/user/import', data, config)
    }

    // 成功
    // 追加後の処理
    // store.commit('setDevices', response)
  },
  async setPost(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [
        {
          locationDataFlag: false,
          userDataBlankFlag: true
        }
      ]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/user/postlist',
      data,
      config
    )
    // 成功
    store.commit('setPosts', response)
  },
  async setSelectedPost(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: [{}]
    }
    var response = await Vue.http.post(
      URL + '/v2/admin/post/list',
      data,
      config
    )
    // 成功
    store.commit('setSelectedPosts', response)
  },
  async fileDownload(store, payload) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30,
      responseType: 'blob'
    }
    var response = await Vue.http.get(
      process.env.API_URL +
        '/v2/admin/userimage/download?filename=' +
        payload +
        '&tenantKey=' +
        header.tenantKey,
      config
    )
    await store.commit('fileDownload', response)
  },
  setNoimageChangeThumbnailPhotograph(store) {
    store.state.changeThumbnailPhotograph = require('../../../img/noimageicon.png')
  },
  fileDownloadErrorFlg(store, payload) {
    store.commit('fileDownloadErrorFlg', payload)
  },
  async setJobs(store) {
    const config = {
      headers: {
        Authorization: master.state.authorization
      },
      timeout: 1000 * 30
    }
    const data = {
      header,
      data: {}
    }
    var response = await Vue.http.post(URL + '/v2/admin/job/list', data, config)
    // 成功
    store.commit('setJobs', response)
  },
  async setExportData(store, payload) {
    let logContinue = true
    let pageNo = 0
    const count = 150
    const margeData = {
      data: {
        header: {},
        data: []
      }
    }
    let totalCount = 0
    while (logContinue) {
      const config = {
        headers: {
          Authorization: master.state.authorization
        },
        timeout: 1000 * 300
      }
      const data = {
        header,
        data: {
          user: payload.userList.slice(pageNo * count, pageNo * count + count),
          jobList: payload.jobList,
          pageNo: payload.userList.length === 0 ? pageNo : 0,
          count: count,
          searchWord: payload.searchWord
        }
      }
      var response = await Vue.http.post(
        URL + '/v2/admin/user/export',
        data,
        config
      )

      const size = response.data['data'].length
      totalCount += size
      for (let i = 0; i < size; i++) {
        margeData.data.data.push(response.data['data'][i])
      }
      pageNo++
      if (size < count) {
        margeData.data.header = response.data['header']
        logContinue = false
      }
      if (
        payload.userList.length > 0 &&
        totalCount >= payload.userList.length
      ) {
        margeData.data.header = response.data['header']
        logContinue = false
      }
    }

    // 成功
    // 追加後の処理
    store.commit('setExportData', margeData)
  }
}
async function loadImageFile(imgFile) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader()
    fileReader.onload = () => {
      resolve(fileReader.result)
    }
    fileReader.readAsDataURL(imgFile)
  })
}
async function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => resolve(img)
    img.onerror = (e) => reject(e)
    img.src = src
  })
}
function getImageScale(img) {
  const size = Math.max(img.width, img.height)
  return 640.0 / size
}
function getImageBlob(img, scale) {
  return new Promise((resolve, reject) => {
    // 透過画像を考慮して 背景 白で描画
    const canvas = document.createElement('canvas')
    canvas.width = img.width * scale
    canvas.height = img.height * scale
    const ctx = canvas.getContext('2d')
    ctx.fillStyle = 'white'
    ctx.fillRect(0, 0, img.width * scale, img.height * scale)
    ctx.drawImage(img, 0, 0, img.width * scale, img.height * scale)
    canvas.toBlob((blob) => resolve(blob), 'image/jpeg', 0.9)
  })
}



// WEBPACK FOOTER //
// ./src/store/modules/careworkerModules/actions.js